interface IRestaurantAddressParts {
    name?: string | null
    address?: string | null
    zipCode?: string | null
    city?: { name?: string | null } | null
    latitude?: number | null
    longitude?: number | null
    placeId?: string | null
}

export const formatRestaurantAddress = (restaurant: IRestaurantAddressParts) => {
    const cityLine = [restaurant.zipCode, restaurant.city?.name].filter(Boolean).join(' ')

    return [restaurant.address, cityLine].filter(Boolean).join(', ')
}

/**
 * Google's universal maps URL: iOS and Android hand it to the Google Maps app
 * when it is installed, every other client falls back to google.com/maps in the
 * browser. `query` stays mandatory even with a place id, which Google then
 * prefers over it to land on the restaurant's place entry instead of a bare pin.
 */
export const buildRestaurantMapsUrl = (restaurant: IRestaurantAddressParts) => {
    const address = formatRestaurantAddress(restaurant)

    const hasCoordinates =
        typeof restaurant.latitude === 'number' && typeof restaurant.longitude === 'number'

    const query = address
        ? [restaurant.name, address].filter(Boolean).join(', ')
        : hasCoordinates
          ? `${restaurant.latitude},${restaurant.longitude}`
          : ''

    if (!query) return null

    const params = new URLSearchParams({ api: '1', query })

    if (restaurant.placeId) params.set('query_place_id', restaurant.placeId)

    return `https://www.google.com/maps/search/?${params.toString()}`
}
